import type { FC } from 'react';
import React from 'react';

import { type BaseSvgProps, colorToHexCode, sizeToSvgWidth } from '../../utils';

export const Sidebar: FC<BaseSvgProps> = ({
  width = sizeToSvgWidth.sm,
  primaryColorHexCode = colorToHexCode.black,
  'data-testid': testId,
}) => (
  <svg
    width={width}
    height={(width * 14) / 12}
    className="shrink-0"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 0.75H11.25V13.25H0.75V0.75ZM2.25 2.25H4.5V11.75H2.25V2.25ZM6 2.25H9.75V11.75H6V2.25Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
